export const ViewStoreTabs = [
    { label: 'Owner Details' },
    { label: 'Store Demographic' },
    { label: 'Parent Store' },
    { label: 'Store Contact’s' },
    { label: 'Address' },
    { label: 'Brand Details' },
]